import type { Format } from './SaloonLobby';
import type { SitgoSeats } from './useLobbyFilters';

/**
 * Ask the lobby to show one of its tabs from anywhere in the app, the same way
 * the cashier asks for the profile panel ('open-profile-panel'). SaloonLobby
 * listens while it is mounted and switches through its own tab handler; with
 * no lobby mounted, nothing happens.
 *
 * For the Sit & Go tab the request can name the seat toggle's side too
 * (EN-10748: the heads-up introduction lands on Heads-up, so six-seat games are
 * out of the way). The lobby stores it as the player's own choice, which the
 * tab's pills and the filter drawer read while the seat toggle flag is on.
 */
export const SHOW_LOBBY_FORMAT_EVENT = 'show-lobby-format';

export type ShowLobbyFormatOptions = { sitgoSeats?: SitgoSeats };

export type ShowLobbyFormatDetail = { format: Format } & ShowLobbyFormatOptions;

export const showLobbyFormat = (format: Format, options: ShowLobbyFormatOptions = {}): void => {
  window.dispatchEvent(
    new CustomEvent<ShowLobbyFormatDetail>(SHOW_LOBBY_FORMAT_EVENT, {
      detail: { format, ...options }
    })
  );
};
